import React from 'react';
import {
    Button,
    Col,
    CustomInput,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Row
} from 'reactstrap';
import logo from '../../assets/images/logo/svg/logo.svg';
import xcaretLogo from '../../assets/images/logo/svg/gpo-xcaret-h-logo-w.svg';
import {ErrorMessage, Field, Form, Formik} from 'formik';
import * as Yup from 'yup';
import {authenticationService} from '../../jwt/_services';
import {cons} from "../../assets/react-css/const";
import {showToastCustom} from "../../components/toast/customToast";
import {error, loginErrorMsg} from "../../components/i18n/i18n";

const customStyle = {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
};


const loginBackground = {
    backgroundColor: '#0D142F',
    borderRadius: '10px 0px 0px 10px',
};

const backgroundInputs = {
    borderRadius: '0px 10px 10px 0px',
};

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isPasswordShown: false
        };
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        let elem = document.getElementById('loginform');
        elem.style.transition = "all 2s ease-in-out";
        elem.style.display = "none";
        document.getElementById('recoverform').style.display = "block";
    }

    togglePasswordVisiblity = () => {
        this.setState({isPasswordShown: !this.state.isPasswordShown})
    };

    render() {
        return (
            <div className="auth-wrapper "   style={cons.emptyBackground} >
                    <div className="auth-wrapper  align-items-center d-flex" >
                    {/*--------------------------------------------------------------------------------*/}
                    {/*Login Cards*/}
                    {/*--------------------------------------------------------------------------------*/}
                    <div className="container">
                        <div>

                            <Row className="no-gutters justify-content-center">
                                <Col md="6" lg="4" className="text-white bringFront" style={loginBackground}>
                                    <div className="p-5 text-white">
                                        <center>
                                            <span className="db"><img height={"136.05px"} width={"216.63px"} src={logo}
                                                                      alt="logo"/></span>
                                        </center>
                                    </div>
                                    <div className={"footer"}>
                                        <center>
                                            <span className="font-bold"><img src={xcaretLogo}/></span>
                                        </center>
                                    </div>
                                </Col>
                                <Col md="6" lg="4" className="bg-white bringFront" style={backgroundInputs}>
                                    <div className="p-4">
                                        <div className={"titulo"}
                                             style={{fontSize: "16px", lineHeight: "21px"}}>Registrarse
                                        </div>
                                        <Formik
                                            initialValues={{
                                                username: '',
                                                password: ''
                                            }}
                                            validationSchema={Yup.object().shape({
                                                username: Yup.string().required('El nombre de usuario es requerido'),
                                                password: Yup.string().required('La contraseña es requerida')
                                            })}
                                            onSubmit={({username, password}, {setStatus, setSubmitting}) => {
                                                setStatus();
                                                authenticationService.login(username, password)
                                                    .then(
                                                        user => {
                                                            if (user == null || user == undefined){
                                                                setSubmitting(false);
                                                                showToastCustom(error, loginErrorMsg, true);
                                                            }else {
                                                                const {from} = {from: {pathname: "/modules/main"}};
                                                                this.props.history.push(from);
                                                            }
                                                        },
                                                        error => {
                                                            showToastCustom(error, loginErrorMsg, true);
                                                            setSubmitting(false);
                                                        }
                                                    );
                                            }}
                                            render={({errors, status, touched, isSubmitting}) => (
                                                <Form className="mt-3" id="loginform">
                                                    <InputGroup className="mb-3">
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText className={"text-white background-color-primary"}>
                                                                <i className="text-white fas fa-user"/>
                                                            </InputGroupText>
                                                        </InputGroupAddon>

                                                        <Field name="username" type="text"
                                                               className={'form-control' + (errors.username && touched.username ? ' is-invalid' : '')}/>
                                                        <ErrorMessage name="username" component="div"
                                                                      className="invalid-feedback"/>
                                                    </InputGroup>
                                                    <InputGroup className="mb-3">
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText className={"text-white background-color-primary"}>
                                                                <i className="fas fa-key"/>
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Field name="password"
                                                               type={this.state.isPasswordShown ? "text" : "password"}
                                                               className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')}/>
                                                        <InputGroupAddon addonType="append">
                                                            <Button color="text-white background-color-primary" onClick={this.togglePasswordVisiblity}>
                                                                {this.state.isPasswordShown ? <i className="text-white fas fa-eye-slash"/>:
                                                                    <i className="text-white fas fa-eye"/>}
                                                            </Button>
                                                        </InputGroupAddon>
                                                        <ErrorMessage name="password" component="div"
                                                                      className="invalid-feedback"/>

                                                    </InputGroup>
                                                    <div className="d-flex no-block align-items-center mb-3">
                                                        <CustomInput type="checkbox" id="exampleCustomCheckbox"
                                                                     label="Recuérdame"/>
                                                    </div>
                                                    <Row className="mb-3">
                                                        <Col xs="12">
                                                            <button style={{boxShadow: "0px 6px 6px rgba(169, 186, 250, 0.36)"}}
                                                                    type="submit"
                                                                    className="btn btn-block text-white background-color-primary"
                                                                    disabled={isSubmitting}>Iniciar sesión
                                                            </button>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            )}
                                        /></div>
                                </Col>
                            </Row>
                            {/*<Particles*/}
                            {/*    width={'100%'}*/}
                            {/*    height={'100%'}*/}
                            {/*    params={{*/}
                            {/*        particles: {*/}
                            {/*            number: {*/}
                            {/*                value: 75*/}
                            {/*            },*/}
                            {/*            move: {*/}
                            {/*                speed: 1*/}
                            {/*            },*/}
                            {/*            size: {*/}
                            {/*                value: 3*/}
                            {/*            }*/}
                            {/*        },*/}
                            {/*        interactivity: {*/}
                            {/*            events: {*/}
                            {/*                onhover: {*/}
                            {/*                    enable: true,*/}
                            {/*                    mode: 'repulse'*/}
                            {/*                }*/}
                            {/*            }*/}
                            {/*        }*/}
                            {/*    }}*/}
                            {/*    style={customStyle}*/}
                            {/*/>*/}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Login;
